<template>
    <div>
        <PageTitle :title="$t('eventos.title')"/>
        <FirstBanner/>

        <div class="container mt-2">
            <SearchEvents
                :placeholder="$t('teatros.buscar_placeholder')"
                :teatro="configuracion.hash_teatro"
            />
        </div>

        <ListadoEventosImagen
            v-if="events.data.length > 0" 
            :eventos="events.data"
        />
        <template v-else>
            <NoEvents/>
        </template>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle'
    import FirstBanner from '@/components/frontend/shared/FirstBanner'
    import ListadoEventosImagen from '@/components/frontend/events/listado/ListadoEventosImagen';
    import SearchEvents from '@/components/frontend/events/SearchEvents'
    import NoEvents from '@/components/frontend/events/listado/NoEvents';

    export default {
        computed: {
            configuracion() {
                return this.$store.getters.getConfig
            },
            footer() {
                return this.$store.getters.getFooter
            },
            events() {
                return this.$store.getters.getFrontEvents;
            }
        },
        components: {
            PageTitle,
            FirstBanner,
            SearchEvents,
            ListadoEventosImagen,
            NoEvents
        },
    }
</script>
